import { Box, Stack } from "@mui/material";
import { useProductContext } from "../ProductContext";
import { SummaryData } from "./SummaryData";
import { ScoreChart } from "src/components/ScoreChart/ScoreChart";
import { WhiteBox } from "@foodpilot/foods";

export const Summary = () => {
    const { allScoreWithVariations, selectedScore, isLoading, isRefetching, productDetailBuilder } =
        useProductContext();

    const chartValues = productDetailBuilder.getSummarytoChartValue();
    if (chartValues === null) return null;

    return (
        <WhiteBox gap={4} px={4} py={3.5} sx={{ backgroundColor: "white" }} borderRadius={4}>
            <Stack gap={3} direction="row" justifyContent="space-between">
                <Stack flex={5} gap={3}>
                    <SummaryData />
                </Stack>
                <Box flex={2}>
                    <ScoreChart
                        allScoreWithVariations={allScoreWithVariations}
                        selectedScore={selectedScore}
                        totalScore={chartValues.totalScore}
                        data={chartValues}
                        isLoading={isLoading}
                        isRefetching={isRefetching}
                        disableVariations={true}
                    />
                </Box>
            </Stack>
        </WhiteBox>
    );
};
